import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 11,
	height: 16,
	viewBox: "0 0 11 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.93279 5.9L4.18764 -2.97778e-07L0 -4.80825e-07L7.83652 8L-6.99382e-07 16L4.16805 16L9.93279 10.15L10.2854 9.79C10.743 9.32139 11 8.68669 11 8.025C11 7.36331 10.743 6.72861 10.2854 6.26L9.93279 5.9Z",
		fill: "currentColor"
	})
});
export default SvgArrowRight;
